// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-company{position:relative;margin-top:40px}@media (max-width:767px){.contact-company{margin-top:0}}.contact-company .contact-company__widget.modal-widget__absolute-wrapper{color:#000;background-color:#fff;border:2px solid #a363ff}.contact-company .contact-company__form{padding:60px 40px 40px}", ""]);
// Exports
module.exports = exports;
